// Misc
import { withStyles } from '@material-ui/core/styles'
import Menu from '@material-ui/core/Menu'

// Styles
const styles = {
  paper: {
    boxShadow: '0 4px 20px 1px rgba(0, 0, 0, 0.08)',
    borderRadius: 6,
  }
}

export default withStyles(styles)(Menu)
